import { render, staticRenderFns } from "./SidebarShow.vue?vue&type=template&id=297d4406"
import script from "./SidebarShow.vue?vue&type=script&lang=js"
export * from "./SidebarShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports